import { Component, ChangeEvent } from "react";
import CertificateDataService from "../../services/certificate.service";
import { UploadFileData } from "../../types/certificate.type";
import CircularProgress from '@mui/material/CircularProgress';
import Header from "../common/header";
type Props = {
  history: any,
};

type State = UploadFileData & {
  err: String,
  files: "",
  iserror: String,
  loading:Boolean
};

class Tranningupload extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      files: "",
      err: "",
      iserror: "",
      loading:false
    };
  }

  onChangeTitle = (e: ChangeEvent<HTMLInputElement>) => {
    // console.log(e);
    this.setState({
      files: e.target.files,
    });
  };
 
  uploadFile = () => {
    // console.log(this.state,'this.state')
    if (!this.state.files) {
      return this.setState({
        err: "Please select an excel file!",
        iserror: "alert-warning",
      });
    } else
    
    {
      this.setState({loading:true})
      let data = new FormData();
      data.append("file", this.state.files[0]);
      CertificateDataService.tranuplaod(data)
        .then((response: any) => {
          if (response.status === 200) {
            this.setState({
              err: response?.data?.message,
              iserror: "alert-success",
              loading:false
            });
            this.props.history.goBack();
          } else {
            this.setState({
              err: response?.statusText,
              iserror: "alert-danger",
              loading:false
            });
          }
        })
        .catch((e) => {
          this.setState({
            err: e.response?.data?.message
              ? e.response?.data?.message
              : e.response?.statusText,
            iserror: "alert-danger",
            loading:false
          });
        });
    }
  };

  render() {
    const { err } = this.state;
    return (
      <>
      <Header/>
      <div className="submit-form mt-2">
        <div>
          <div className="form-group ">
            <label className="mb-3" htmlFor="title">
              Upload Medical File (only .xlsx file)
            </label>
            <input
              className="form-control form-control-lg"
              type="file"
              onChange={this.onChangeTitle}
            />
          </div>
          <div className="w-full   mt-5 flex justify-center items-center">
            <button 
              onClick={this.uploadFile}
              className="btn btn-success w-72 py-3"
            >
              {this.state.loading?  <CircularProgress />  :"UPLOAD"}
    
            </button>
          </div>
          <div style={{ marginTop: 50 }} />
          {err && (
            <div className={`alert ${this.state.iserror}`} role="alert">
              <div className="alert-link">{err}</div>
            </div>
          )}
        </div>
      </div>
      </>
    );
  }
}

export default Tranningupload;
